import { DocumentNode } from 'apollo-link';
import gql from 'graphql-tag';

export const CustomSqlFragmentGql: DocumentNode = gql`
fragment CustomSqlFragment on Datasource {
  fields {
    ...on ColumnField {
      columns {
        table {
          ...on CustomSQLTable {
            id
            name
            isUnsupportedCustomSql
            query
          }
        }
      }
    }
  }
}
`;
